<template>
  <h1>Logging out...</h1>
</template>

<script>

export default {

  data() {
    return {
      show: true
    }
  },
  created(){

    localStorage.clear()
    window.location = "/"

  }
}
</script>
